import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { publicApi } from "@/lib/publicApi";
import { PageHero, SectionTitle } from "@/components/public/Primitives";
import PricingCard from "@/components/public/PricingCard";
import FAQAccordion from "@/components/public/FAQAccordion";
import { Button } from "@/components/ui/button";
import CTASection from "@/components/public/CTASection";
import SEO from "@/components/public/SEO";

export default function Pricing() {
    const [packages, setPackages] = useState([]);
    const [faqs, setFaqs] = useState([]);

    useEffect(() => {
        publicApi.get("/pricing").then((r) => setPackages(r.data || [])).catch(() => {});
        publicApi.get("/faqs").then((r) => setFaqs(r.data || [])).catch(() => {});
    }, []);

    return (
        <div data-testid="pricing-page">
            <SEO
                title="Affordable Website & App Packages | Omega IT Ltd Pricing"
                description="Transparent fixed-price packages: Starter Website £499, Business Growth £1,499, Advanced Business System custom quote. No hidden fees, capped prices, UK small business focus."
            />
            <PageHero eyebrow="Pricing" title="Clear packages, capped prices." subtitle="Pick the package that fits your stage or get a free custom quote for a more involved build. No hidden fees." />
            <section className="px-5 sm:px-8 lg:px-12 py-20">
                <div className="max-w-6xl mx-auto grid lg:grid-cols-3 gap-5">
                    {packages.map((p) => (<PricingCard key={p.id} pkg={p} />))}
                </div>
            </section>
            <section className="px-5 sm:px-8 lg:px-12 pb-20">
                <div className="max-w-3xl mx-auto bg-slate-50 border border-slate-200 rounded-3xl p-10 text-center">
                    <h2 className="font-display text-2xl sm:text-3xl font-black text-slate-950">Not sure which fits?</h2>
                    <p className="text-slate-600 mt-3 max-w-xl mx-auto">Tell us what you do and what you'd like to achieve — we'll come back within one working day with a recommendation or a fixed quote.</p>
                    <Button asChild size="lg" className="mt-7 bg-slate-950 hover:bg-slate-800 text-white"><Link to="/contact?intent=audit">Get a free website audit</Link></Button>
                </div>
            </section>
            <section className="px-5 sm:px-8 lg:px-12 pb-20">
                <div className="max-w-3xl mx-auto">
                    <SectionTitle eyebrow="FAQ" title="Pricing & process questions." align="center" />
                    <div className="mt-10"><FAQAccordion faqs={faqs} /></div>
                </div>
            </section>
            <CTASection />
        </div>
    );
}
